import { render, staticRenderFns } from "./project-tracker-dashboard.vue?vue&type=template&id=b94a8a26&scoped=true&"
import script from "./project-tracker-dashboard.vue?vue&type=script&lang=js&"
export * from "./project-tracker-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./project-tracker-dashboard.vue?vue&type=style&index=0&id=b94a8a26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94a8a26",
  null
  
)

export default component.exports